import { render, staticRenderFns } from "./wxOrder.vue?vue&type=template&id=2170a308&scoped=true&"
import script from "./wxOrder.vue?vue&type=script&lang=js&"
export * from "./wxOrder.vue?vue&type=script&lang=js&"
import style0 from "./wxOrder.vue?vue&type=style&index=0&id=2170a308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170a308",
  null
  
)

export default component.exports